<i18n>
  {
  "ru": {
  "addItem": "Добавить товар",
  "name": "Название",
  "brand": "Бренд",
  "brands": "Бренды",
  "art": "Артикул",
  "category": "Категория",
  "price": "Цена",
  "sizes": "Размеры",
  "select-cat": "Входи в",
  "select-def": "Корень сайта",
  "desc" : "Описание",
  "add": "Добавить",
  "image": "Картинка",
  "images": "Картинки",
  "create": "Создать",
  "save" : "Сохранить",
  "close": "Закрыть",
  "remove": "Удалить",
  "status": {
    "active" : "Активный",
    "disable": "Выключена"
  }
  },
  "uk": {
  "addItem": "Додати товар",
  "name": "Назва",
  "brand": "Бренд",
  "brands": "Бренды",
  "art": "Артикул",
  "category": "Категорія",
  "price": "Ціна",
  "sizes": "Розміри",
  "select-cat": "Заходить у",
  "select-def": "Корінь сайту",
  "desc" : "Опис",
  "add": "Додати",
  "image": "Зображення",
  "images": "Картинки",
  "stock": "Знижка",
  "create": "Створити",
  "save" : "Зберегти",
  "close": "Закрити",
  "remove": "Вилучити",
  "status": {
    "active" : "Активний",
    "disable": "Вимкнений"
  }
  }
  }
</i18n>
<template>
  <div>
    <div class="row">
      <div class="col-md-12 change-lang">
        <router-link class="locale" :to="{ params: { locale: 'ru' } }">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAGFBMVEVHcEz/PgDf4eGqsdKASnn/PQDg4eI/UbUIMKX5AAAABXRSTlMAgIDAwJ6ZvvQAAAA3SURBVBjTY2AgAzApwYECA1saHCQQy2E2hgMDBvZyOCgglsPiAgcODKyhcBBALIdREA4EyAkCAFaFO+fKN2UpAAAAAElFTkSuQmCC"
          />
          Русский</router-link
        >
        <router-link class="locale" :to="{ params: { locale: 'uk' } }"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAD1BMVEVHcEz91zYilfMhlvP92DVw3Q5rAAAAA3RSTlMAgIAsTd+1AAAAJklEQVQY02NgIAMwKcGBAgOzMRwYUJnD4gIHDlTmMArCgQA5QQAAdeEl/Xx287cAAAAASUVORK5CYII="
          />
          Украинский</router-link
        >
      </div>
    </div>
    <div class="btn-block-top row">
      <div class="col-md-3"></div>
      <div class="col-md-9">
        <button
          class="btn btn-primary"
          @click.prevent="showAddItem = !showAddItem"
        >
          {{ $t("addItem") }}
        </button>
      </div>
    </div>
    <div class="create-block" v-if="showAddItem">
      <b-card>
        <form name="addItem" @submit.prevent="addItem">
          <div class="form-group">
            <label>{{ $t("name") }}:</label>
            <input
              type="text"
              name="name"
              required
              class="form-control"
              v-model="form.name[locale]"
            />
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label>{{ $t("brand") }}:</label>
              <select
                class="form-control"
                name="cat-id"
                v-model="form.brand_id"
              >
                <option
                  v-for="brand in $store.state.GlobalData.brands"
                  :key="brand.id"
                  :value="brand.id"
                >
                  {{ brand.name[locale] }}
                </option>
              </select>
            </div>
            <div class="form-group col-6">
              <label>{{ $t("art") }}:</label>
              <input
                type="text"
                name="art"
                required
                class="form-control"
                v-model="form.art"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label>{{ $t("category") }}:</label>
              <select
                class="form-control"
                name="cat-id"
                v-model="form.category_id"
              >
                <option
                  v-for="cat in $store.state.GlobalData.categories"
                  :key="cat.id"
                  :value="cat.id"
                >
                  {{ cat.name[locale] }}
                </option>
              </select>
            </div>
            <div class="form-group col-6">
              <label>{{ $t("price") }}:</label>
              <input
                type="text"
                name="price"
                required
                class="form-control"
                v-model="form.price"
              />
            </div>
          </div>
          <div class="form-group">
            <label>{{ $t("sizes") }}:</label>
            <p class="text-danger text-err" v-if="err">
              Этот размер уже используется в данном товаре!
            </p>
            <b-input-group class="mb-3">
              <select name="sizes" class="form-control" v-model="sizeID">
                <option
                  v-for="item in $store.state.GlobalData.sizes"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name[locale] }} -
                  {{ item.short_name[locale] }}</option
                >
              </select>
              <b-input-group-append>
                <b-button
                  size="sm"
                  text="Button"
                  variant="success"
                  @click.prevent="addSizeToItem('add')"
                  >{{ $t("add") }}</b-button
                >
              </b-input-group-append>
            </b-input-group>
            <div class="add-block-size" v-if="form.sizes.length > 0">
              <div
                class="input-group"
                v-for="size in form.sizes"
                :key="size.id"
              >
                <div class="input-group-prepend">
                  <span class="input-group-text"
                    >{{ size.name[locale] }} -
                    {{ size.short_name[locale] }}</span
                  >
                </div>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Количество"
                  v-model="size.quantity"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    @click.prevent="removeSizeToItem('add', size)"
                  >
                    {{ $t("remove") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>{{ $t("desc") }}:</label>
            <textarea
              class="form-control"
              name="description"
              v-model="form.description[locale]"
            ></textarea>
          </div>
          <div class="form-group">
            <label>{{ $t("image") }}:</label>
            <file-pond
              name="image"
              ref="pond"
              label-idle="Для загрузки кликни или перетащи файл..."
              allow-multiple="true"
              allowImageResize="true"
              imageResizeTargetWidth="800"
              imageResizeTargetHeight="600"
              imageResizeUpscale="false"
              accepted-file-types="image/jpg, image/jpeg, image/png"
              server="https://may-ua.com.ua/uploader/upload.php"
              v-bind:files="myFiles"
              v-on:init="handleFilePondInit"
              @processfile="onLoad"
            />
          </div>
          <div class="btn-actions">
            <button type="submit" class="btn btn-primary btn-sm">
              {{ $t("create") }}
            </button>
            <button
              type="button"
              class="btn btn-link btn-sm"
              @click.prevent="showAddItem = !showAddItem"
            >
              {{ $t("close") }}
            </button>
          </div>
        </form>
      </b-card>
    </div>
    <div class="as-datatable">
      <b-table
        bordered
        striped
        hover
        small
        :busy="!isBusy"
        :items="$store.state.GlobalData.products"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template v-slot:cell(name)="row">
          {{ row.item.name[locale] }}
        </template>
        <template v-slot:cell(brand)="row">
          {{ currentBrand(row.item.brand) }}
        </template>
        <template v-slot:cell(images)="row">
          <img class="td_image" :src="row.item.images[0]" />
        </template>
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            @click="row.toggleDetails"
            class="btn btn-primary"
          >
            <font-awesome-icon
              v-if="!row.detailsShowing"
              class="as-icon"
              :icon="['fas', 'pencil-alt']"
            />
            <font-awesome-icon
              v-else
              class="as-icon"
              :icon="['far', 'eye-slash']"
            />
          </b-button>
          <button class="btn btn-danger btn-sm">
            <font-awesome-icon class="as-icon" :icon="['fas', 'trash-alt']" />
          </button>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <form action="#" method="POST" @submit.prevent="savePost(row)">
              <div class="form-group">
                <label>{{ $t("name") }}:</label>
                <input
                  type="text"
                  name="name"
                  class="form-control"
                  v-model="row.item.name[locale]"
                />
              </div>
              <div class="row">
                <div class="form-group col-6">
                  <label>{{ $t("brands") }}:</label>
                  <select
                    class="form-control"
                    name="cat-id"
                    v-model="row.item.brand_id"
                  >
                    <option
                      v-for="brand in $store.state.GlobalData.brands"
                      :key="brand.id"
                      :value="brand.id"
                    >
                      {{ brand.name[locale] }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-6">
                  <label>{{ $t("art") }}:</label>
                  <input
                    type="text"
                    name="art"
                    required
                    class="form-control"
                    v-model="row.item.art"
                  />
                </div>
              </div>
              <div class="row">
                <div class="form-group col-6">
                  <label>{{ $t("category") }}:</label>
                  <select
                    class="form-control"
                    name="cat-id"
                    v-model="row.item.category_id"
                  >
                    <option
                      v-for="cat in $store.state.GlobalData.categories"
                      :key="cat.id"
                      :value="cat.id"
                    >
                      {{ cat.name[locale] }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-6">
                  <label>{{ $t("price") }}:</label>
                  <input
                    type="text"
                    name="price"
                    required
                    class="form-control"
                    v-model="row.item.price"
                  />
                </div>
              </div>
              <div class="row">
                <div class="form-group col-12">
                  <label>{{ $t("sizes") }}:</label>
                  <p class="text-danger text-err" v-if="row.item.err">
                    Этот размер уже используется в данном товаре!
                  </p>
                  <b-input-group class="mb-3">
                    <select
                      name="sizes"
                      class="form-control"
                      v-model="sizeID"
                      @change="verifySizes(row.item.sizes)"
                    >
                      <option
                        v-for="item in $store.state.GlobalData.sizes"
                        :key="item.id"
                        :value="item.id"
                        >{{ item.name[locale] }} -
                        {{ item.short_name[locale] }}</option
                      >
                    </select>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        text="Button"
                        variant="success"
                        @click.prevent="addSizeToItem('edit', row)"
                        :disabled="readeSize"
                        >{{ $t("add") }}</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                  <div class="add-block-size" v-if="row.item.sizes.length >= 1">
                    <div
                      class="input-group"
                      v-for="size in forSizes(row.item.sizes)"
                      :key="size.id"
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text"
                          >{{ size.name[locale] }} -
                          {{ size.short_name[locale] }}</span
                        >
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        name="quantity"
                        placeholder="Количество"
                        v-model="size.quantity"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-secondary"
                          type="button"
                          @click.prevent="removeSizeToItem('edit', size, row)"
                        >
                          {{ $t("remove") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>{{ $t("desc") }}:</label>
                <textarea
                  class="form-control"
                  name="description"
                  v-model="row.item.description[locale]"
                ></textarea>
              </div>
              <div class="form-group">
                <label>{{ $t("images") }}:</label>
                <file-pond
                  name="image"
                  ref="pond"
                  label-idle="Для загрузки кликни или перетащи файл..."
                  allow-multiple="true"
                  allowImageResize="true"
                  imageResizeTargetWidth="800"
                  imageResizeTargetHeight="600"
                  imageResizeUpscale="false"
                  accepted-file-types="image/jpeg, image/png"
                  :server="{
                    process: 'https://may-ua.com.ua/uploader/upload.php',
                    load:
                      'https://s3.eu-central-1.amazonaws.com/img.baby/products/'
                  }"
                  @processfile="onLoadEdit"
                  @removefile="removeFileEdit"
                  v-bind:files="row.item.kostil"
                />
              </div>
              <div class="actions-btn">
                <button
                  class="btn btn-primary btn-sm"
                  type="submit"
                  :disabled="row.item.ready"
                >
                  {{ $t("save") }}
                </button>
                <button
                  class="btn btn-link btn-sm"
                  type="button"
                  @click.prevent="row.toggleDetails"
                >
                  {{ $t("close") }}
                </button>
              </div>
            </form>
          </b-card>
        </template>
      </b-table>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="itemsAll"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import Axios from "axios";

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageResize,
  FilePondPluginImageTransform
);
export default {
  //props: ["products", "categories", "sizes"],
  data() {
    return {
      locale: this.$route.params.locale,
      myFiles: [],
      err: false,
      showAddItem: false,
      sizeID: null,
      readeSize: false,
      form: {
        name: {
          ru: null,
          uk: null
        },
        brand_id: null,
        art: null,
        images: [],
        price: null,
        sizes: [],
        description: {
          ru: null,
          uk: null
        },
        category_id: null,
        status: 1
      },
      currentPage: 1,
      perPage: 5,
      itemsAll: 0,
      isBusy: true,
      sortBy: "status",
      fields: [
        {
          key: "art",
          label: "Код товара",
          sortable: false
        },
        {
          key: "images",
          label: "Картинка",
          sortable: false
        },
        {
          key: "name",
          label: "Название",
          sortable: true
        },
        {
          key: "brand_id",
          label: "Бренд",
          sortable: false
        },
        {
          key: "price",
          label: "Цена",
          sortable: true
        },
        {
          key: "actions",
          label: "Действия",
          sortable: false
        }
      ]
    };
  },
  methods: {
    verifySizes(el) {
      for (let i = 0; i < el.length; i++) {
        if (el[i].id === this.sizeID) {
          this.readeSize = true;
          this.err = true;
          return true;
        }
      }
      this.err = false;
      this.readeSize = false;
    },
    addSizeToItem(type, row) {
      let store = this.$store.state.GlobalData.sizes;
      if (type === "edit") {
        for (let i = 0; i < store.length; i++) {
          if (store[i].id === this.sizeID) {
            row.item.sizes.push({
              id: store[i].id,
              quantity: store[i].quantity
            });
            this.sizeID = null;
          }
        }
      } else {
        for (let i = 0; i < store.length; i++) {
          if (store[i].id === this.sizeID) {
            store[i].quantity = 0;
            this.form.sizes.push(store[i]);
            this.sizeID = null;
          }
        }
      }
    },
    removeSizeToItem(type, size, row) {
      if (type === "add") {
        for (let i = 0; i < this.form.sizes.length; i++) {
          if (this.form.sizes[i].id === size.id) {
            this.form.sizes.splice(i, 1);
          }
        }
        this.verifySizes(this.form.sizes);
      } else if (type === "edit") {
        for (let i = 0; i < row.item.sizes.length; i++) {
          if (row.item.sizes[i].id === size.id) {
            row.item.sizes.splice(i, 1);
          }
        }
        this.verifySizes(row.item.sizes);
      }
    },
    forSizes(sizes) {
      let store = this.$store.state.GlobalData.sizes;
      let arr = new Array();
      for (let i = 0; i < store.length; i++) {
        for (let s = 0; s < sizes.length; s++) {
          if (sizes[s].id === store[i].id) {
            store[i].quantity = sizes[s].quantity;
            arr.push(store[i]);
          }
        }
      }
      return arr;
    },
    savePost(el) {
      el.item.ready = true;
      let form = {
        id: el.item.id,
        name: el.item.name,
        brand_id: el.item.brand,
        art: el.item.art,
        images: el.item.images,
        price: el.item.price * 100,
        sizes: el.item.sizes,
        description: el.item.description,
        category_id: el.item.category_id,
        status: el.item.status
      };
      Axios.post("/.netlify/functions/product-update", form)
        .then(function() {
          el.item.ready = false;
          el.toggleDetails(false);
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    addItem() {
      let _this = this;
      let store = this.$store.state.GlobalData.products;
      this.form.price = this.form.price * 100;
      let arr = [];
      for (let i = 0; i < this.form.sizes.length; i++) {
        arr.push({
          id: this.form.sizes[i].id,
          quantity: this.form.sizes[i].quantity
        });
      }
      this.form.sizes = arr;
      Axios.post("/.netlify/functions/product-create", this.form).then(function(
        res
      ) {
        let newItem = {};
        _this.form.id = res.data.ref["@ref"].id;
        for (let key in _this.form) {
          newItem[key] = _this.form[key];
        }
        newItem.price = parseFloat(newItem.price) / 100;
        store.push(newItem);
        _this.showAddItem = false;
        _this.form = clearForm();
      });
    },
    handleFilePondInit: function() {
      this.$refs.pond.getFiles();
      console.log("init", this.$refs.pond);
      // FilePond instance methods are available on `this.$refs.pond`
    },
    onLoad(formData, file) {
      const image = JSON.parse(file.serverId).full;
      this.form.images.push(image);
    },
    onLoadEdit(formData, file) {
      let store = this.$store.state.GlobalData.products;
      const image = JSON.parse(file.serverId).full;
      for (let i = 0; i < store.length; i++) {
        if (store[i]._showDetails) {
          store[i].images.push(image);
          let obj = {
            source: image
              .split("/")
              .splice(5, 4)
              .join("/")
              .toString(),
            options: { type: "local" }
          };
          store[i].kostil.push(obj);
        }
      }
    },
    removeFileEdit(formData, file) {
      let store = this.$store.state.GlobalData.products;
      for (let i = 0; i < store.length; i++) {
        if (store[i]._showDetails) {
          for (let img = 0; img < store[i].images.length; img++) {
            if (store[i].images[img].indexOf(file.source) !== -1) {
              store[i].images.splice(img, 1);
              store[i].kostil.splice(img, 1);
            }
          }
        }
      }
    },
    currentBrand(id) {
      let brands = this.$store.state.GlobalData.brands;
      let str = null;
      let self = this;
      brands.forEach(function(el) {
        if (el.id === id) {
          str = el.name[self.locale];
        }
      });
      return str;
    }
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    }
  },
  components: {
    FilePond
  }
};

function clearForm() {
  let form = {
    name: {
      ru: null,
      uk: null
    },
    brand_id: null,
    art: null,
    images: [],
    price: null,
    sizes: [],
    description: {
      ru: null,
      uk: null
    },
    category_id: null,
    status: 1
  };
  return form;
}
</script>
